import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/firestore';

import { uid } from 'uid';

import { keys } from 'lodash';

export const unsubscribeAllSnapshots = () =>
  new Promise((resolve) => {
    const snapshotListeners = Vue.prototype.$snapshots;

    keys(snapshotListeners).forEach((snapshotUnsubscribe) => {
      snapshotListeners[snapshotUnsubscribe] &&
        snapshotListeners[snapshotUnsubscribe]();
    });

    resolve();
  });

export const getOrgId = async (email = '', scac = '', newAgent = null) => {
  const invitationsCollection = await firebase
    .firestore()
    .collection('invitations')
    .where('email', '==', email)
    .get();
  const inviteDoc = invitationsCollection.docs[0];
  let organizationDoc = null;
  if (scac) {
    const organizationsCollection = await firebase
      .firestore()
      .collection('organizations')
      .where('scac', '==', scac.toUpperCase())
      .get();
    organizationDoc = organizationsCollection.docs[0];
  }
  if (organizationDoc) {
    if (newAgent) {
      return uid(28);
    }
    const { orgId } = organizationDoc.data();

    return orgId;
  } else if (inviteDoc) {
    const { orgId } = inviteDoc.data();

    return orgId || uid(28);
  } else {
    return uid(28);
  }
};
